import { ReactNode, createContext, useContext, useState } from "react";
import React from "react";

interface CheckBoxCadastroProviderProps {
  children: ReactNode;
}

interface CheckBoxCadastroProps {
  isTodosChecked: boolean
  getTodosChecked: (checked: boolean) => void
}

const CheckBoxCadastro = createContext<CheckBoxCadastroProps>({} as CheckBoxCadastroProps);

export const CheckBoxCadastroProvider = ({ children }: CheckBoxCadastroProviderProps) => {
  const [isTodosChecked, setIsTodosChecked] = useState(false)

  function getTodosChecked(checked: boolean) {
    setIsTodosChecked(checked)
  }


  return (
    <CheckBoxCadastro.Provider value={{
      isTodosChecked,
      getTodosChecked
    }}>
      {children}
    </CheckBoxCadastro.Provider>
  );
};

export const useCheckBoxCadastro = () => useContext(CheckBoxCadastro);


